import { RootState } from 'common/redux'
import { ParamName, ParamValue } from './param-toggler-models'

export type ParamTogglerState = {
	params: Record<ParamName, ParamValue>
}

const initialState: ParamTogglerState = {
	params: {},
}

export type ParamTogglerAction =
	| {
			type: 'SSE_PARAM_TOGGLED_ON'
			payload: {
				param: ParamName
			}
	  }
	| {
			type: 'SSE_PARAM_TOGGLED_OFF'
			payload: {
				param: ParamName
			}
	  }
	| {
			type: 'SSE_PARAM_TOGGLER_STATE_REQUESTED'
			payload: { paramMap: Record<ParamName, ParamValue> }
	  }
	| { type: 'SET_JOINED_ROOM' }
	| {
			type: 'PARAM_TOGGLED_LOCALLY'
			payload: { param: ParamName; value: boolean }
	  }

// What this client just asked the server for, applied before the SSE echo.
export const setParamLocally = (
	param: ParamName,
	value: boolean
): ParamTogglerAction => ({
	type: 'PARAM_TOGGLED_LOCALLY',
	payload: { param, value },
})

export function reducer(
	state: ParamTogglerState = initialState,
	action: ParamTogglerAction
): ParamTogglerState {
	switch (action.type) {
		case 'SSE_PARAM_TOGGLED_ON': {
			return {
				...state,
				params: {
					...state.params,
					[action.payload.param]: true,
				},
			}
		}
		case 'SSE_PARAM_TOGGLED_OFF': {
			return {
				...state,
				params: {
					...state.params,
					[action.payload.param]: false,
				},
			}
		}
		case 'SSE_PARAM_TOGGLER_STATE_REQUESTED': {
			return {
				...state,
				params: action.payload.paramMap,
			}
		}
		case 'PARAM_TOGGLED_LOCALLY': {
			return {
				...state,
				params: {
					...state.params,
					[action.payload.param]: action.payload.value,
				},
			}
		}
		// Params live on a room's param toggler feature. The new room's
		// INITIAL_STATE replays its own map; until then nothing is known.
		case 'SET_JOINED_ROOM': {
			return {
				...state,
				params: {},
			}
		}
		default: {
			return state
		}
	}
}

export const selectParam = (
	state: RootState,
	paramName: ParamName
): ParamValue | undefined => {
	return state.paramToggler.params[paramName]
}

export const redux = {
	reducer,
}
